import React from 'react';
import '../RNModal/RNModal.scss';
// import { Button } from '@mui/material';
//import CustomButton from '../ui/Button/Button';

const RNModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

 
  return (
      
    <div className="modal-overlay">
      <div className="modal-content" >     
        <h2 className='release-modal-header'>VFLOW - Release Notes</h2>
        <div className="close-button">
          <button onClick={onClose}>✖</button>
        </div>
          <p className="subtitle">A changelog of the latest updates.</p>
        <div className="release-item">
           <p className="release-date">June 26, 2025</p>
                <h3 className="release-heading">Dashboard Improvements</h3>
                <ol className="release-content">
                  <li>
                    <strong>Conditional Store Visibility:</strong> Stores are now displayed based on user roles (e.g., Admin, Manager), helping users focus only on relevant data.
                  </li>
                  <li>
                    <strong>Responsive Target Display:</strong> Target numbers (MTT, activations, etc.) are now easier to read on mobile and tablet devices.
                  </li>
                 <li>
                    <strong>Improved Pie Chart View:</strong> The pie chart adapts better to smaller screens, ensuring cleaner and more readable visualization.
                  </li>
                  
                  <li>
                    <strong>Faster Graph Response Time:</strong> Backend optimization has improved the loading time for the Activation and Revenue charts.
                  </li>
                </ol>

                <h3 className="release-heading">View Attach Rate Updates</h3>
                <ol className="release-content">
                  <li>
                    <strong>Manager-Based Employee Filter:</strong> You can now filter employee data based on the selected manager—useful for team-level reviews.
                  </li>
                  <li>
                    <strong>Optimized for Small Screens:</strong> Attach rate data tables have been refined for easier scrolling and readability on mobile devices.
                  </li>
                </ol>   
              <p className="release-date">June 4, 2025</p>
              <h3 className="release-heading">Target Widget Updates</h3>
              <p className="release-content">Enhancements to reporting options and AR details:</p>
              <ol className="release-content">
                <li>Data is available on daily, weekly, and monthly basis only.</li>
                <li>
                  Accessory Attach Rate (AR) is added:
                  <ul>
                    <li><strong>Total:</strong> Accessory sold % with activations and HUP only.</li>
                    <li><strong>Activations:</strong> Accessory sold with activations.</li>
                    <li><strong>HUP:</strong> Accessory sold with HUP.</li>
                  </ul>
                </li>
                <li>PPP, PPP+, AC etc. now show more details.</li>
          </ol>

           <p className="release-date">May 29, 2025</p>
              <h3 className="release-heading">CIS Upload is Updated</h3>
              <p className="release-content">The following improvements have been made:</p>
              <ol className="release-content">
                <li>Users are now able to upload CIS and RQ4 invoices easily.</li>
                <li>Duplicate files will not be added.</li>
              </ol>

              <h3 className="release-heading">Dashboard Updates</h3>
              <p className="release-content">Improvements made to phone protection and accessory data:</p>
              <ol className="release-content">
                <li>Phone protection plans (PPP) show correct values.</li>
                <li>Accessories percentage is no longer zero.</li>
              </ol>

          
           </div>

          
             {/* directly get it from git? but user readable */ }
       
                          {/*
                              db integration is needed to add file upload to  reduce manual work  in code.
                              <ul>
                            <li><strong>v1.2.0:</strong> Added PDF validation, AutoPay support</li>
                            <li><strong>v1.1.0:</strong> Alerts for invoice errors.</li>
                          </ul>
                            </p>
              </div>   */}
         
        </div>
       
    </div>
  );
};

export default RNModal;
